import { api } from 'api'
import { useQuery } from '@tanstack/react-query'
import { toaster } from 'uikit/Toaster'

export const useFetchItem = (id: string) => {
  const response = useQuery({
    queryKey: ['useFetchFaqItem', id],
    queryFn: () => api.faq.fetchItem(id),
    gcTime: 0,
    enabled: !!id,
  })

  if (response.isError) {
    toaster.create({
      type: 'error',
      title: 'Произошла ошибка при загрузке faq',
      description: response.error?.message,
    })
  }

  return response
}
